/**
 * Enquiry types for the /book form (server: enquiry_type enum). `fields` lists
 * the extra fields each type needs; `required` the ones that must be filled.
 * A table request is a REQUEST: staff confirm it later in the portal.
 */
export const enquiryTypes = [
  { value: "table", label: "Table Booking", fields: ["date", "time", "guests"], required: ["date", "time", "guests"], maxGuests: 50 },
  { value: "private", label: "Private Event", fields: ["occasion", "date", "time", "guests"], required: ["date", "guests"], maxGuests: 500 },
  { value: "catering", label: "Catering", fields: ["date", "guests"], required: ["date", "guests"], maxGuests: 500 },
  { value: "general", label: "General Enquiry", fields: [], required: ["message"], maxGuests: 500 },
];

/** Occasions listed by the owner for private events. */
export const privateOccasions = [
  "Birthday party",
  "Private party",
  "Funeral reception",
  "Other",
];
